/* screens/kitchen/KitchenShell.jsx — оболочка раздела «Кухня» (window.KitchenScreen).
   PageHeader + 4 вкладки (Сырьё/Полуфабрикаты/Блюда/Проекты меню).
   Тело — активный реестр. При stack.length>0 — DrawerStackRenderer (overlay) с крошками.
   Переключение вкладки сбрасывает q/type/status/allergen/source/sort/edit.
   Legacy-редирект ?tab=recipes&kind=semiproduct → ?tab=semiproducts.
   ХЕНДОФФ → frontend/pages/kitchen/Kitchen.jsx. */

import React from 'react';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { DrawerStackRenderer } from '../../components/patterns/kitchen/DrawerStackRenderer.jsx';
import { hooks } from '../../hooks/index.jsx';
import { RR } from '../../lib/router.jsx';
import { IngredientEditor } from './editors/IngredientEditor.jsx';
import { MenuEditor } from './editors/MenuEditor.jsx';
import { TTKEditor } from './editors/TTKEditor.jsx';
import { IngredientsRegistry } from './registries/IngredientsRegistry.jsx';
import { MenusRegistry } from './registries/MenusRegistry.jsx';
import { RecipeRegistry } from './registries/RecipeRegistry.jsx';

  const { useEffect } = React;
  const { useSearchParams } = RR;
  const { useDrawerStack } = hooks;

  const TABS = [
    { id: 'ingredients', label: 'Сырьё', onb: 'tab-ingredients' },
    { id: 'semiproducts', label: 'Полуфабрикаты', onb: 'tab-semiproducts' },
    { id: 'recipes', label: 'Готовые позиции', onb: 'tab-recipes' },
    { id: 'menus', label: 'Проекты меню', onb: 'tab-menus' },
  ];
  const VALID = TABS.map((t) => t.id);

  function KitchenScreen() {
    const [params, setParams] = useSearchParams();
    const { stack, popTo, popAll, pop } = useDrawerStack();

    // legacy-редирект: recipes&kind=semiproduct → semiproducts
    useEffect(() => {
      if (params.get('tab') === 'recipes' && params.get('kind') === 'semiproduct') {
        setParams((prev) => {
          const sp = new URLSearchParams(prev); sp.set('tab', 'semiproducts'); sp.delete('kind'); return sp;
        }, { replace: true });
      }
      // eslint-disable-next-line
    }, [params]);

    const rawTab = params.get('tab') || 'ingredients';
    const tab = VALID.includes(rawTab) ? rawTab : 'ingredients';

    // переключение вкладки: чистим все локальные параметры (включая ?edit)
    const switchTab = (id) => setParams(() => {
      const sp = new URLSearchParams(); sp.set('tab', id); return sp;
    });

    let body = null;
    if (tab === 'ingredients') body = <IngredientsRegistry />;
    else if (tab === 'semiproducts') body = <RecipeRegistry kind="semiproduct" />;
    else if (tab === 'recipes') body = <RecipeRegistry kind="dish" />;
    else if (tab === 'menus') body = <MenusRegistry />;

    return (
      <div className="section-page">
        <PageHeader subtitle="Рабочее пространство" title="Продукция"
          tabs={TABS} activeTab={tab} onTab={switchTab} />
        <div className="section-body">{body}</div>

        <DrawerStackRenderer
          stack={stack} registry={{ ttk: TTKEditor, card: IngredientEditor, menu: MenuEditor }}
          onClose={pop} onPopTo={popTo} onRoot={popAll} />
      </div>
    );
  }

export { KitchenScreen };
